import "./index.scss";
import { useAppSelector } from "@hooks/redux";
import { useBodyScroll } from "@hooks/utils";
import report from "@report";
import { PAGES } from "@routes";
import Modal from "@src/ui/Modal";
import { copyToClipboard } from "@utils/copy";
import message from "@utils/message";
import { useOpenWindow } from "@utils/window";
import { CommonButton } from "@components/CommonButton";
import { Trans } from "react-i18next";

interface ScriptSuccessModalProps {
  script: string;
  visible: boolean;
  onCancel: () => void;
}

export default ({ script, visible, onCancel }: ScriptSuccessModalProps) => {
  const { videoId } = useAppSelector((state) => state.globalVideoReducer);
  const { openWindow } = useOpenWindow();
  useBodyScroll(visible);

  return (
    <Modal className="LayoutVideoDownloading-ScriptSuccessModal" open={visible} footer={false} onCancel={onCancel}>
      <div className="p-[16px]">
        <div className="title">
          <Trans>Transcript Export</Trans>
        </div>
        <div className="script">
          {script.split("\n").map(function (item, idx) {
            return (
              <span key={idx}>
                {item}
                <br />
              </span>
            );
          })}
        </div>
        <div className="btns">
          <CommonButton
            className="h-[46px] w-[136px]"
            type="primary"
            onClick={() => {
              copyToClipboard(script).then(() => {
                message.success("Copy succeed");
              });
              report.event("script_ai_copy", { kalo_value: videoId });
            }}
          >
            <Trans>Copy</Trans>
          </CommonButton>
          <CommonButton
            className="h-[46px] min-w-[190px]"
            type="primary"
            onClick={() => {
              // dispatch(showGlobalAI({ from: GlobalAIFrom.SCRIPT, script }));
              // report.event("script_ai_optimize", { kalo_value: videoId });
              report.click({
                kalo_type: "script_optimizer",
                kalo_pos: "transcript",
              });
              openWindow(PAGES.AI_VIDEO_INSIGHT + `?id=${videoId}`);
            }}
          >
            <Trans>AI Script Writer</Trans>
          </CommonButton>
        </div>
      </div>
    </Modal>
  );
};
